import { FC, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import {
  LoadDocBtn,
  Step,
  TableWrapper,
  UiList,
} from '@ru-digital-assets/ui-component';
import UcpDocs from '../../../components/ucp-sign/ucp-docs/ucp-docs';
import UcpHeader from '../../../components/ucp-sign/ucp-header/ucp-header';
import UcpSignForm from '../../../components/ucp-sign/ucp-sign-form/ucp-sign-form';
import FormFooter from '../../../containers/form-footer';
import AppPageMain from '../../../modules/app-page/app-page--main';
import PageHeader from '../../../modules/page-header';
import { useAppDispatch } from '../../../store';
import {
  getExchange,
  getExchangeAgreement,
} from '../../../store/actions/exchange';
import { signExchange } from '../../../store/actions/operations-sign';
import { RootState } from '../../../types';
import {
  downloadFile,
  getPdfFromBase64,
} from '../../../utils/files/downloadFile';
import ExchangeParams from 'components/ExchangeParams';
import { createHash } from 'crypto-pro';
import { IconBtn } from '@ru-digital-assets/ui-component';
import SignIcon from 'assets/icons/sign-icon';
import './index.scss';
import { useCallback } from 'react';
import { cryptoSignExchange } from '../../../store/actions/operations-sign';
import './index.scss';
import '../../../modules/common-icons/modal.scss';
import '../../../components/key-storage/index.scss';
import { OperationComplete, BlockchainExplorerButton } from 'components';
import { PrivateKeyButton } from 'components';
import { CopyIcon } from 'assets/icons';
import { useSign } from 'hooks';
import { getFormatDate } from 'utils/utils';
import { getExchangeStatusBadge } from 'utils/getStatusBadge';

const ExchangeRequest: FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { id } = history.location.state;

  const companyInfo = useSelector(
    (state: RootState) => state.companiesInfo.companies
  );
  const loadingSign = useSelector(
    (state: RootState) => state.operationsSign.loading.exchange
  );
  const exchangeInfo = useSelector(
    (s: RootState) => s.operationsSign.data.exchange
  );
  const paymentTokens = useSelector(
    (state: RootState) => state.commonInfo.paymentTokens
  );
  const [document, setDocument] = useState<{ doc: string; hash: string }>();

  console.log('exchangeInfo.status', exchangeInfo?.status);

  const {
    certificatesList,
    selectedCertificate,
    signEntity,
    onUserSelectCertificate,
    usersCertificates,
  } = useSign();

  const currentCert = useMemo(() => {
    return usersCertificates.find(
      (certificate) => certificate.thumbprint === selectedCertificate?.value
    );
  }, [usersCertificates, selectedCertificate]);

  const updateApplication = useCallback(() => {
    dispatch(getExchangeAgreement({ id, signed: false })).then((res: any) => {
      // TODO: remove mock
      if (!res.payload) {
        createHash(JSON.stringify({ data: 'Test' })).then((hash) => {
          setDocument({ doc: 'Test', hash });
        });
      }
      // END TODO

      setDocument(res.payload);
    });

    dispatch(getExchange(id));
  }, [id]);

  useEffect(() => {
    updateApplication();
  }, [updateApplication]);

  const decisionDocs = useMemo(() => {
    const docs: any[] = [];

    const isSig = exchangeInfo?.status !== 'INITIALIZED';
    const isCounterSig = exchangeInfo?.status === 'AGENT_DOC_SIGNED' ||
      exchangeInfo?.status === 'COMPLETED';

    docs.push(
      <LoadDocBtn
        title="Заявка на обмен"
        extension=".PDF"
        onSpecDownload={() => {
          if (document?.doc) {
            const resultBlob = getPdfFromBase64(document?.doc);
            downloadFile(resultBlob, 'Заявка на обмен.pdf', 'application/pdf');
          }
        }}
        secondExtension={isSig ? '.SIG' : undefined}
        onSecondSpecDownload={
          isSig
            ? () => {
                dispatch(getExchangeAgreement({ id, signed: true })).then(
                  (res: any) => {
                    const resultBlob = getPdfFromBase64(
                      btoa(String.fromCharCode(...new Uint8Array(res.payload)))
                    );
                    downloadFile(
                      resultBlob,
                      'Заявка на обмен.pdf.sig',
                      'application/pdf'
                    );
                  }
                );
              }
            : undefined
        }
      />
    );

    (((exchangeInfo?.status === 'INITIATOR_SIGNED' && !exchangeInfo?.isInitiator) ||
      (exchangeInfo?.status === 'AGENT_DOC_SIGNED') || (exchangeInfo?.status === 'COMPLETED')) &&
    docs.push(
      <LoadDocBtn
        title="Встречная заявка"
        extension=".PDF"
        onSpecDownload={() => {
          if (document?.doc) {
            const resultBlob = getPdfFromBase64(document?.doc);
            downloadFile(resultBlob, 'Встречная заявка.pdf', 'application/pdf');
          }
        }}
        secondExtension={isSig ? '.SIG' : undefined}
        onSecondSpecDownload={
          isCounterSig
            ? () => {
              dispatch(getExchangeAgreement({ id, signed: true })).then(
                (res: any) => {
                  const resultBlob = getPdfFromBase64(
                    btoa(String.fromCharCode(...new Uint8Array(res.payload)))
                  );
                  downloadFile(
                    resultBlob,
                    'Встречная заявка.pdf.sig',
                    'application/pdf'
                  );
                }
              );
            }
            : undefined
        }
      />
    ));

    return docs;
  }, [document]);

  const onClose = () => history.push('/exchange');

  const onSubmit = async () => {
    const idIsValid = Number.isFinite(+id);
    if (currentCert && document?.hash && idIsValid) {
      const { pdfSigned } = await signEntity(document?.hash);
      if (pdfSigned) {
        dispatch(
          signExchange({
            hash: document.hash,
            signature: pdfSigned,
            id,
          })
        ).then(() => {
          updateApplication();
        });
      }
    }
  };

  const initiatorList = [
    {
      label: 'Оферент:',
      value: exchangeInfo?.initiatorCompanyName || '-',
    },
    {
      label: 'ИНН:',
      value: companyInfo[exchangeInfo?.initiatorId]?.tin || '-',
    },
  ];

  const recipientList = [
    {
      label: 'Адресат оферты:',
      value: exchangeInfo?.public
        ? 'Публичное размещение'
        : exchangeInfo?.agentCompanyName,
    },
    {
      label: 'ИНН',
      value: exchangeInfo?.public
        ? '-'
        : companyInfo[exchangeInfo?.agentId]?.tin,
    },
  ];

  const datesList = [
    {
      label: 'Дата создания заявки:',
      value: exchangeInfo.createdDate
        ? getFormatDate(exchangeInfo.createdDate, undefined, true)
        : '-',
    },
    {
      label: 'Дата исполнения сделки:',
      value: exchangeInfo.completeDate
        ? getFormatDate(exchangeInfo.completeDate, undefined, true)
        : '-',
    },
  ];

  const [showSignResultScreen, setShowSignResultScreen] = useState(false);

  const handleCryptoSign = async () => {
    dispatch(
      cryptoSignExchange({
        info: {
          operationId: id,
          privateKey: privateKey,
        },
        callback: () => {
          updateApplication();
          setShowSignResultScreen(true);
        },
      })
    );
  };

  const [privateKey, setPrivateKey] = useState('');

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                {
                  link: '/exchange',
                  title: 'Обмен',
                },
              ]}
              iconType={'exchange'}
            />
          </div>
        </div>
        {showSignResultScreen ? (
          <OperationComplete
            title="Обмен цифровых финансовых активов"
            onClose={() => history.push('/assets')}
            main={
              <>
                <p className="p p_font-size_32 p_font-weight_light mb_32 text-center">
                  {exchangeInfo?.isInitiator
                    ? 'Заявка на обмен подписана'
                    : 'Обмен произведен'}
                </p>
                {exchangeInfo?.isInitiator ? (
                  <p className="p p_font-size_18 mb_32 text-center">
                    Транзакция заявки на обмен {exchangeInfo?.tokenCountFrom}{' '}
                    токенов{' '}
                    {
                      paymentTokens.find(
                        (p) => p.code === exchangeInfo?.tokenNameFrom
                      )?.name
                    }
                    <br />
                    на {exchangeInfo?.tokenCountTo} токенов{' '}
                    {
                      paymentTokens.find(
                        (p) => p.code === exchangeInfo?.tokenNameTo
                      )?.name
                    }{' '}
                    успешно подписана
                  </p>
                ) : (
                  <p className="p p_font-size_18 mb_32 text-center">
                    Обмен {exchangeInfo?.tokenCountFrom} токенов{' '}
                    {
                      paymentTokens.find(
                        (p) => p.code === exchangeInfo?.tokenNameFrom
                      )?.name
                    }
                    <br />
                    на {exchangeInfo?.tokenCountTo} токенов{' '}
                    {
                      paymentTokens.find(
                        (p) => p.code === exchangeInfo?.tokenNameTo
                      )?.name
                    }{' '}
                    успешно произведен
                  </p>
                )}
                {exchangeInfo?.blockchainTransactionId && (
                  <div className="flex align-center mb_32">
                    <p className="p p_font-size_18 mr_10">
                      ID транзакции:{' '}
                      {exchangeInfo?.blockchainTransactionId.slice(0, 20) +
                        '..' +
                        exchangeInfo?.blockchainTransactionId.slice(-15)}
                    </p>
                    <CopyIcon
                      className="cursor-pointer"
                      width={20}
                      height={20}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          exchangeInfo.blockchainTransactionId
                        );
                      }}
                    />
                  </div>
                )}
                <div className="flex">
                  <div className="mr_16">
                    <BlockchainExplorerButton trxnId={exchangeInfo.blockchainTransactionId}/>
                  </div>
                  <IconBtn
                    title="Перейти в операции"
                    onClick={() => history.push('/history')}
                  />
                </div>
              </>
            }
          />
        ) : (
          <TableWrapper>
            <div className="ucp">
              <UcpHeader
                isExchange
                title={
                  exchangeInfo?.status === 'INITIALIZED' ? (
                    <p className="p p_font-weight_600 p_color_orange">
                      Проверьте и подпишите заявку
                    </p>
                  ) : undefined
                }
                onClose={onClose}
              />
              <div className="ucp__body">
                <div className="ucp__left">
                  <div className="ucp__top">
                    <Step
                      steps={[
                        { title: 'Параметры' },
                        {
                          title: 'Подпись',
                          active:
                            exchangeInfo?.status === 'INITIALIZED' ||
                            exchangeInfo?.status === 'INITIATOR_DOC_SIGNED',
                        },
                        {
                          title: 'Согласование',
                          active: exchangeInfo?.status === 'INITIATOR_SIGNED',
                        },
                        {
                          title: 'Обмен',
                          active: exchangeInfo?.status === 'AGENT_DOC_SIGNED',
                        },
                      ]}
                    />
                    <h3 className="h3">
                      {exchangeInfo?.status !== 'AGENT_SIGNED' &&
                        `Заявка №${exchangeInfo.id}:`}
                    </h3>
                    <p>{`Заявка на обмен ${
                      exchangeInfo?.tokenCountFrom
                    } токенов "${
                      paymentTokens.find(
                        (p) => p.code === exchangeInfo?.tokenNameFrom
                      )?.name
                    }" на ${exchangeInfo?.tokenCountTo} токенов "${
                      paymentTokens.find(
                        (p) => p.code === exchangeInfo?.tokenNameTo
                      )?.name
                    }"`}</p>
                    <div className="mt_8">
                      {getExchangeStatusBadge(
                        exchangeInfo?.status,
                        exchangeInfo?.isInitiator
                      )}
                    </div>
                  </div>
                  <div className="ucp__content">
                    <div className="ucp__ontractors">
                      <h3 className="h3">Детали операции:</h3>
                      <div className="ucp__ontractors-body">
                        <div className="ucp__ontractors__left">
                          <UiList list={initiatorList} sm />
                        </div>
                        <div className="ucp__ontractors__right">
                          <UiList list={recipientList} sm />
                        </div>
                        <div className="ucp__ontractors__right">
                          <UiList list={datesList} sm />
                        </div>
                      </div>
                    </div>
                    <UcpDocs docs={decisionDocs} />
                    {(exchangeInfo?.status === 'INITIATOR_DOC_SIGNED' &&
                      exchangeInfo?.isInitiator) ||
                    (exchangeInfo?.status === 'AGENT_DOC_SIGNED' &&
                      !exchangeInfo?.isInitiator) ? (
                      <>
                        <FormFooter>
                          <div className="flex justify-end form-asset-credit__container">
                            <div className="flex justify-end issuer-footer align-center">
                              <div className="flex justify-end">
                                <div className="mr_10">
                                  <PrivateKeyButton
                                    onKeyChange={(key) =>
                                      setPrivateKey(key || '')
                                    }
                                  />
                                </div>
                                <br />
                                <IconBtn
                                  onClick={handleCryptoSign}
                                  lg
                                  disabled={!privateKey}
                                  icon={<SignIcon />}
                                  title="Подписать транзакцию"
                                />
                              </div>
                            </div>
                          </div>
                        </FormFooter>
                      </>
                    ) : (exchangeInfo?.status === 'INITIALIZED' &&
                        exchangeInfo?.isInitiator) ||
                      (exchangeInfo?.status === 'INITIATOR_SIGNED' &&
                        !exchangeInfo?.isInitiator) ? (
                      <UcpSignForm
                        selected={selectedCertificate}
                        onCertSelect={onUserSelectCertificate}
                        onSubmit={onSubmit}
                        disabled={!currentCert || loadingSign}
                        backCallback={() => history.push(`/assets`)}
                        btnText="Подписать заявку"
                        certsList={certificatesList}
                      />
                    ) : exchangeInfo?.status === 'INITIATOR_SIGNED' &&
                      exchangeInfo?.isInitiator ? null : (
                      <FormFooter />
                    )}
                  </div>
                </div>
                <div className="ucp__right">
                  {exchangeInfo && <ExchangeParams />}
                </div>
              </div>
            </div>
          </TableWrapper>
        )}
      </div>
    </AppPageMain>
  );
};

export default ExchangeRequest;
